import { Icon } from "@iconify/react";

import { PaymentMethodIconConfig } from "@/types/subscription";

import CardIcon from "./CardIcon";

interface PaymentIconProps extends PaymentMethodIconConfig {
  className?: string;
}

const PaymentIcon = ({ type, name, ...otherProps }: PaymentIconProps) => {
  if (type === "iconify") {
    return <Icon icon={name} {...otherProps} />;
  }

  return <CardIcon brand={name} {...otherProps} />;
};

export default PaymentIcon;
